import React from 'react';
import SelectInput from "@/Shared/SelectInput";
import TextInput from "@/Shared/TextInput";
import TextArea from "@/Shared/TextArea";
import CustomCheckbox from "@/Shared/CustomCheckbox";

const PublishCouponForm = ({data, errors, setData, discount_type}) => {
  return (
    <div className="flex flex-wrap p-8 -mb-8 -mr-6">
      <SelectInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Discount type"
        name="discount_type"
        errors={errors.discount_type}
        value={data.discount_type}
        onChange={e => setData('discount_type', e.target.value)}
      >
        {discount_type.map(({discount_type, description}) => (
          <option key={discount_type} value={discount_type}>
            {description}
          </option>
        ))}
      </SelectInput>
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Value"
        name="value"
        type="number"
        step="any"
        errors={errors.value}
        value={data.value}
        onChange={e => setData('value', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Max Value"
        name="max_value"
        type="number"
        step="any"
        errors={errors.max_value}
        value={data.max_value}
        onChange={e => setData('max_value', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Min Amount"
        name="min_amount"
        type="number"
        step="any"
        errors={errors.min_amount}
        value={data.min_amount}
        onChange={e => setData('min_amount', e.target.value)}
      />

      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Keywords"
        name="keywords"
        type="text"
        errors={errors.keywords}
        value={data.keywords}
        onChange={e => setData('keywords', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Title"
        name="link_name"
        type="text"
        errors={errors.link_name}
        value={data.link_name}
        onChange={e => setData('link_name', e.target.value)}
      />
      <TextArea
        className="w-full pb-8 pr-6"
        label="Comments"
        name="comments"
        errors={errors.comments}
        value={data.comments}
        onChange={e => setData('comments', e.target.value)}
      />
      <CustomCheckbox
        className="w-full pb-8 pr-6"
        label="Free Ship"
        name="free_ship"
        errors={errors.free_ship}
        checked={data.free_ship}
        onChange={e => setData('free_ship', e.target.checked)}
      />
      <CustomCheckbox
        className="w-full pb-8 pr-6"
        label="Show Online"
        name="showonline"
        checked={data.showonline}
        errors={errors.showonline}
        onChange={e => setData('showonline', e.target.checked)}
      />
    </div>
  );
};

export default PublishCouponForm;
